<template>
  <RawRecords v-if="showRawOutput" :records="records" />
  <table v-else-if="processedRecords.length">
    <colgroup>
      <col style="width: 17%;">
      <col style="width: 17%;">
      <col style="width: 17%;">
      <col style="width: 25%;">
      <col style="width: 24%;">
    </colgroup>
    <thead>
      <tr>
        <th scope="col" class="py-1.5 font-medium">Priority</th>
        <th scope="col" class="py-1.5 font-medium">Weight</th>
        <th scope="col" class="py-1.5 font-medium">Port</th>
        <th scope="col" class="py-1.5 font-medium">Target</th>
        <th scope="col" class="py-1.5 font-medium">Revalidate in</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, index) in processedRecords" :key="index" class="group">
        <td><span>{{record.record.priority}}</span> <span v-if="record.record.priority === minPriority" class="badge badge-secondary">
          Primary</span></td>
        <td>{{ record.record.weight }}</td>
        <td>{{ record.record.port }}</td>
        <td>
          <dns-records-link :domain="record.record.target" class="text-blue-600 hover:text-blue-800 hover:underline" />
          <CnameChainBadge :chain="record.cnameChain" />
          <copy :content="record.record.target" class="[visibility:hidden] group-hover:visible" /></td>
        <td><duration :seconds="record.record.ttl" /></td>
      </tr>
    </tbody>
  </table>
  <div v-else>No {{ recordType.plural }} found.</div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Duration from '@/components/micro/DurationComponent.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { getRecordType } from '@/common/recordTypes';
import { QueryResult, RecordInfo, SRV } from '@/model/Api';

type SrvRecordWithInfo = {
  record: SRV;
} & RecordInfo

const recordType = getRecordType('SRV');

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
});

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: SrvRecordWithInfo[] = props.records.response.answer.filter((item): item is SrvRecordWithInfo => item.record.recordType === recordType.upper);
  processed.sort((a, b) => a.record.priority - b.record.priority);

  return processed;
});

const minPriority = computed(() => Math.min(...processedRecords.value.map((r) => r.record.priority)));
</script>
